 export enum PrimoboxEtatTraitement {
NonDistribue = 0,
TraitementEnCours = 1,
TraitementTermineAvecAnomalies = 2,
ValidationEnAttente = 3,
DistributionEnCours = 4,
Termine = 5,
Erreur = 6,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/PrimoboxEtatTraitement.ts